let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l5nPd")).then(() => parcelRequire('iy8ZX'));